/** Ermittelt das "Beratungsthema" für die KI-Vorschlags-Prompts (Ist-Zustand/Stärken/
 *  Schwächen etc.) — MUSS den ausführlichen Beratungsauftrag (1.1, Feld 'consulting-purpose')
 *  bevorzugen, nicht nur den knappen Berichtstitel. Ein Titel wie "#2 Barrierefreiheit" reicht
 *  der KI allein nicht als Themensignal und verliert gegen den ausführlicheren, aber
 *  themenfremden Geschaeftsgegenstand/Branche-Kontext im selben Prompt (Root Cause
 *  LIVIN'ROLL-Vorfall 2026-07-23: Bericht behandelte ab Abschnitt 2 die generische
 *  Unternehmensstruktur statt digitale Barrierefreiheit). */
export function resolveBeratungsthema(formData: Record<string, unknown>): string {
  const auftrag = typeof formData['consulting-purpose'] === 'string' ? formData['consulting-purpose'].trim() : '';
  if (auftrag) return auftrag;
  const titel = typeof formData['berichtstitel'] === 'string' ? formData['berichtstitel'].trim() : '';
  return titel;
}
